import { EnumBadge } from '@mxa-argos/components/custom/enum-badge';
import { IconLabel } from '@mxa-argos/components/custom/icon-label';
import { SearchItemLayout } from '@mxa-argos/modules/search/components/search-item-layout';
import type { SearchResult } from '@mxa-argos/modules/search/hooks/use-resource-search';
import { FileStack, User } from 'lucide-react';

interface Props {
  result: SearchResult;
}

export function SubscriptionSearchItem({ result }: Props) {
  return (
    <SearchItemLayout
      icon={FileStack}
      primary={result.primary}
      secondary={
        result.secondary && (
          <EnumBadge enumName="SubscriptionStatus" value={result.secondary} size="sm" />
        )
      }
      tertiary={result.tertiary}
      quaternary={result.quaternary && <IconLabel icon={User} value={result.quaternary} />}
    />
  );
}
